import React, {PureComponent} from 'react'
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles/index';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Avatar from '@material-ui/core/Avatar';
import MessageContent from "./MessageContent";

const styles = theme => ({
    messageInputWrapper: {
        height: 64,
        display: 'flex',
        alignItems: 'center',
    },
    attachmentInputWrapper: {
        display: 'flex',
        alignItems: 'center',
        marginTop: -16,
        paddingBottom: 8,
        paddingLeft: 8,
    },
    sendIconButton: {
        padding: 14,
        paddingRight: 24,
        marginTop: -2,
    },
    sendIcon: {},
    messageInput: {
        marginLeft: theme.spacing(2.5),
        flex: 1,
    },
    iconButtonRoot: {
        width: 42,
        height: 42,
        margin: '8px 8px 0 0',
        padding: 0,
    },
    attachIconButton: {},
});

class SendMessage extends PureComponent {
    state = {};

    render() {
        const {classes, handleChange, onSendMessage, newMessage} = this.props;

        return (<>
                <div className={classes.messageInputWrapper}>
                    <InputBase className={classes.messageInput} placeholder="Mitä haluaisit kysyä tai kertoa?"
                               name="newMessage"
                               value={newMessage}
                               onChange={handleChange}/>
                    <IconButton color="primary" className={classes.sendIconButton} aria-label="Send"
                                onClick={onSendMessage} disabled={newMessage === ''}>
                        <FontAwesomeIcon size={'sm'} icon={['fal', 'paper-plane']}
                                         className={classes.sendIcon}/>
                    </IconButton>
                </div>
                {false && <div className={classes.attachmentInputWrapper}>
                    <IconButton color="primary" className={classes.attachIconButton} aria-label="Send"
                                onClick={this.onSendMessage} disabled={newMessage === ''}>
                        <FontAwesomeIcon size={'sm'} icon={['fal', 'file-contract']}
                                         className={classes.sendIcon}/>
                    </IconButton>
                </div>}
            </>
        );
    }
}

SendMessage.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SendMessage);
